import { render, staticRenderFns } from "./LmSvgIcon.vue?vue&type=template&id=76060f10&"
import script from "./LmSvgIcon.vue?vue&type=script&lang=js&"
export * from "./LmSvgIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports